import React, { FC, forwardRef } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, Divider } from '@material-ui/core'
import { Announcement, SettingsInputAntenna } from '@material-ui/icons'
import { hooks } from '../../../libs'

const useStyles = makeStyles(() =>
  createStyles({
    textLabel: {
      fontSize: 14,
      marginBottom: 5,
    },
    menuItem: {
      '&.active': {
        background: 'rgba(0, 0, 0, 0.08)',
      },
    },
    menuItemIcon: {
      minWidth: 32,
    },
    menuItemText: {
      '& > span': {
        fontSize: '14px',
      },
    },
  }),
)

export const ToLOperationsSidebar: FC = () => {
  const classes = useStyles()
  const { hasNotificationPermission, hasOtacMaintenancePermission } = hooks.useTolOperation()

  const navLinkProps = (path: string) => ({
    button: true as const,
    className: classes.menuItem,
    component: forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
      <NavLink {...props} innerRef={ref} isActive={(_, location) => location.pathname.startsWith(path)} />
    )),
  })

  return (
    <>
      <Box p={2}>
        <Typography className={classes.textLabel} display="block">
          ToL
        </Typography>
      </Box>
      <Divider />
      <Box py={1}>
        <List component="nav" disablePadding>
          {hasNotificationPermission && (
            <ListItem {...navLinkProps('/tol-operations/notifications')} to="/tol-operations/notifications">
              <ListItemIcon className={classes.menuItemIcon}>
                <Announcement />
              </ListItemIcon>
              <ListItemText className={classes.menuItemText} primary="お知らせ管理" />
            </ListItem>
          )}
          {hasOtacMaintenancePermission && (
            <ListItem {...navLinkProps('/tol-operations/otac-maintenance')} to="/tol-operations/otac-maintenance">
              <ListItemIcon className={classes.menuItemIcon}>
                <SettingsInputAntenna />
              </ListItemIcon>
              <ListItemText className={classes.menuItemText} primary="OTACメンテナンススケジュール設定" />
            </ListItem>
          )}
        </List>
      </Box>
    </>
  )
}
